import dynamic from 'next/dynamic';
import Title from "@/components/Title";

const LifeAtMedhavi = dynamic(() => import('@/components/Home2/LifeAtMedhavi'));

// Rich Text helper for Strapi Blocks
const renderRichText = (blocks) => {
  if (typeof blocks === 'string') return blocks;
  if (Array.isArray(blocks)) {
    return blocks.map(block => {
      if (block.type === 'paragraph') {
        return block.children.map(child => child.text).join('');
      }
      return '';
    }).join('\n');
  }
  return '';
};

const LifeAtMsuSection = ({ data, loading }) => {
  const sectionTitle = data?.Title || "Life at MSU: Building Skills Beyond the Classroom";
  const sectionDescription = renderRichText(data?.Description) || "Experience vibrant campus life at MSU, where workshops spark innovation, clubs build networks, sports fuel energy, fests unleash creativity, and community projects create real impact.";

  return (
    <section className="w-full mx-auto bg-cover bg-center bg-no-repeat bg-[url('/life-at-msu.svg')]">
      <div className="w-full inner_top_bottom_space">
        <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
          <div className="w-full lg:w-[90%] heading_space_bottom">
            <Title
              heading={sectionTitle}
              subText={sectionDescription}
              color="text-white"
              subTextColor="text-white/70"
              align="text-left"
            />
          </div>
          <LifeAtMedhavi data={data} loading={loading} />
        </div>
      </div>
    </section>
  );
};

export default LifeAtMsuSection;
